<script setup lang="ts">
/* @deprecated Use @tix/ds/components/atoms/BaseCard.vue instead */
import type { HTMLAttributes } from 'vue'

export type BaseCardProps = {
  /** HTML element to render as (polymorphic component). The consumer is responsible for resetting styles for the element passed (e.g., button, a). See AsButton story. */
  is?: keyof HTMLElementTagNameMap
  /** Additional CSS classes to apply to the card */
  class?: HTMLAttributes['class']
  /** Enable hover effect with lift and shadow */
  hoverable?: boolean
  /** Remove default padding from the card */
  unpadded?: boolean
}

const props = withDefaults(defineProps<BaseCardProps>(), {
  is: 'div',
})
</script>

<template>
  <component :is="is" :class="['base-card', props.class, { hoverable, unpadded }]">
    <slot />
  </component>
</template>

<style scoped>
.base-card {
  /* Local Themable Variables */
  --_border-width: var(--base-card-border-width, var(--border-width));
  --_border-radius: var(--base-card-border-radius, var(--card-border-radius));
  --_transition-duration: var(--base-card-transition-duration, var(--transition-duration));

  /* Card styles */
  display: block;
  width: 100%;
  background-color: var(--action-card-bg);
  border-width: var(--_border-width);
  border-style: solid;
  border-color: var(--card-border);
  border-radius: var(--_border-radius);
  padding: var(--space-1-5);
  box-shadow: var(--card-shadow);

  &.unpadded {
    padding: 0;
  }

  &.hoverable {
    cursor: pointer;
    transition:
      background-color var(--_transition-duration) ease-out,
      border-color var(--_transition-duration) ease-out,
      box-shadow var(--_transition-duration) ease-out,
      transform var(--_transition-duration) ease-out;

    &:focus-visible,
    &:active {
      background-color: var(--action-card-bg-active);
      border-color: var(--action-card-border-active);
      box-shadow: var(--card-shadow-hover);
      transform: translateY(-2px);
    }

    &:hover {
      background-color: var(--action-card-bg-hover);
      border-color: var(--card-border);
      box-shadow: var(--card-shadow-hover);
      transform: translateY(-2px);
    }
  }
}
</style>
